export default {
  placeOfWork: {},
}
